module.exports = __webpack_public_path__ + "img/guzzle.532d7581.svg";